import { captureException } from "@sentry/react"
import axios from "api/axios"
import { APIResponse, Config } from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"
import { AxiosError } from "axios"

import { LaunchPracticeInterviewResponse } from "./types"
import { urls } from "./urls"

export default {
  /**
   * `data.generateMagicLink` must stay `false` for passive status checks
   * (page load, polling, window focus) - the backend keeps any link the
   * learner already has open valid. Pass `true` only from the learner's
   * explicit Start/Continue click: that generates a fresh single-use
   * `magicLink` and immediately invalidates the previous one.
   */
  launch: async ({
    data,
  }: Config): Promise<APIResponse<LaunchPracticeInterviewResponse>> => {
    try {
      const res = await axios.post(urls.launch(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      const statusCode = (e as AxiosError | undefined)?.response?.status
      // 401s are handled globally by the auth flow, so they're not worth reporting
      if (statusCode !== 401) {
        captureException(
          new Error(
            `Practice interview launch failed (${statusCode ?? "network"})`
          ),
          scope => {
            scope.setTag("api", "bePracticeInterview.launch")
            scope.setExtras({
              statusCode,
              generateMagicLink: data?.generateMagicLink,
              response: JSON.stringify(
                (e as AxiosError | undefined)?.response?.data ?? null
              ),
            })
            return scope
          }
        )
      }
      return formatErrorResponse(e)
    }
  },
}
